import RoomInfo from './RoomInfo.vue';
export default RoomInfo;
